<template>
  <template v-if="hasPayload">
    <SendTransaction
      :title="title"
      :payload="payload"
      @back="onClose"
      @close="onClose"
      @success="onSuccess"
      @reject="onRejected"
    />
  </template>
</template>

<script setup lang="ts">
import { computed, inject, onBeforeMount, Ref } from 'vue';
import { useDialogStore } from '@/store';
import { SendTransaction } from '@/components/Dialogs/Steps';
import { useI18n } from '@/composables/useI18n';

const { t } = useI18n();

const dialogRef = inject<Ref>('dialogRef');

type IProps = {
  visible?: boolean;
  title?: string;
};

defineProps<IProps>();
defineEmits(['update:visible']);

onBeforeMount(mount);

const dialogStore = useDialogStore();

function onClose() {
  dialogRef?.value.close();
}

function onSuccess() {
  dialogRef?.value?.data?.onSuccess?.();
  onClose();
}

function onRejected() {
  onClose();
}

const hasPayload = computed(() => {
  return !!dialogRef?.value?.data?.payload;
});

const payload = computed(() => {
  return dialogRef?.value?.data?.payload;
});

function mount() {
  dialogStore.setDialogTitle(
    dialogRef?.value?.title ?? t('common.sendTransaction'),
  );
}
</script>

<style lang="scss" scoped></style>
